import { AxiosError } from 'axios';
import { RequestError } from '@/shared/api';

export const getFieldErrorMessage = (error: AxiosError<RequestError>) => {
  const errorData = error.response?.data;

  if (errorData && !!errorData.non_field_errors?.length) {
    return errorData.non_field_errors[0];
  }

  if (errorData && errorData.errors?.length > 0) {
    let loc = '';

    if (errorData?.errors[0].loc.length > 0) {
      loc = `[${errorData?.errors[0].loc.join('.')}]: `;
    }

    return `${loc}${errorData.errors[0].msg}`;
  }

  return error.response?.data.python_exc || error.message;
};
